import { toast } from "react-toastify";
import firebase from "../../config/firebase";

export const getAthleteSummary =
  (oncomplete = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("reset_athlete_summary")
      .onSnapshot(async (query) => {
        let temp_data = [];
        for (let doc of query.docs) {
          if (doc.data()?.athleteID) {
            let user = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data()?.athleteID)
              .get();
            let rating = await firebase
              .firestore()
              .collection("a4b_chat_rating")
              .where("to_id", "==", doc.data().athleteID)
              .get();
            let tempStats = rating.docs.map((doc) => ({
              id: doc.id,
              ...doc.data()
            }));
            const counts = tempStats.reduce((acc, { chatResponse }) => {
              acc[chatResponse] = (acc[chatResponse] || 0) + 1;
              return acc;
            }, {});
            counts.total = tempStats.length;
            const chatQuery = await firebase
              .firestore()
              .collection("new_a4b_chat")
              .where("athleteID", "==", doc.data().athleteID)
              .where("status", "==", "complete")
              .get();
            const tempTotalChat = chatQuery.docs.map((doc) => ({
              status: doc.status
            }));
            let totalChat = tempTotalChat.length;
            temp_data.push({
              id: doc.id,
              count: counts,
              totalChat: totalChat,
              ...user.data()
            });
          } else {
            oncomplete();
          }
        }
        dispatch({
          type: "GET_ATHLETE_SUMMARY",
          payload: temp_data
        });
        oncomplete();
      });
  };

export const acceptAthleteSummary =
  ({ id, name }) =>
  async () => {
    let athleteDoc = await firebase
      .firestore()
      .collection("reset_athlete_summary")
      .doc(id)
      .get();

    if (!athleteDoc.exists) {
      toast.error(`No document found with athleteID: ${id}`);
      return;
    }

    let athleteData = athleteDoc.data();

    await firebase
      .firestore()
      .collection("a4b_chat_rating")
      .where("to_id", "==", athleteData?.athleteID)
      .onSnapshot(async (query) => {
        for (let doc of query.docs) {
          await firebase
            .firestore()
            .collection("a4b_chat_rating")
            .doc(doc.id)
            .update({
              to_id: ""
            });
        }
      });
    firebase
      .firestore()
      .collection("reset_athlete_summary")
      .doc(id)
      .delete()
      .then((query) => {
        toast.success(
          `Athlete ${name} reset rating 0 S, 0 U-NS and 0 U-RST Successfully`
        );
      });
  };

export const rejectAthleteSummary = (id) => () => {
  firebase.firestore().collection("reset_athlete_summary").doc(id).delete();
  toast.success("Athlete reset rating 0 S, 0 U-NS and 0 U-RST Rejected");
};
